import * as React from 'react';
const autobind = require('class-autobind').default;
import { logger } from '@lib/common';
import { Input } from '../../form/input/index';
// import { ProxyDomainCheckUpdateResponse, ProxyDomainCheckUpdateRequest} from "../../../../types/api/index";
import isFQDN from 'validator/lib/isFQDN';
import { InputGroup } from '../../form/input.group/index';
import { RotateLoader } from '../../loaders/rotate/index';
export class FieldDomain extends React.Component {
    timer;
    initialName;
    constructor(props) {
        super(props);
        autobind(this);
        this.state = {
            loading: false,
        };
        this.initialName = props.value;
    }
    validate(value) {
        if (value && value === this.initialName) {
            return '';
        }
        else if (value && !isFQDN(value, { require_tld: true })) {
            return 'Invalid domain name';
        }
        else if (value && (value.match(/\./g) || []).length < 2) {
            return 'Domain name must have a subdomain such as www.example.com or order.example.com';
        }
        return '';
    }
    onChange(e) {
        const { restaurant_id, website_id } = this.props;
        const value = e.target.value;
        this.props.onChange(value);
        if (this.timer) {
            clearTimeout(this.timer);
        }
        const error = this.validate(value);
        if (error) {
            this.props.onError(error);
            this.setState({ loading: false });
        }
        else if (!value || (value && this.initialName === value)) {
            this.props.onError('');
            this.setState({ loading: false });
        }
        else {
            this.props.onError('');
            this.setState({ loading: true });
            this.timer = setTimeout(async () => {
                try {
                    const data = await this.props.check({ restaurant_id, website_id, domain: value });
                    this.props.onError(data.outcome === 1 ? data.message : '');
                }
                catch (e) {
                    this.props.onError('Error validating sub-domain name, please try re-entering the name');
                    logger.captureException(e);
                }
                this.setState({ loading: false });
            }, 1500);
        }
    }
    render() {
        return (React.createElement(InputGroup, { hide: !this.state.loading, side: "right", iconHtml: this.state.loading ? React.createElement(RotateLoader, { size: 2 }) : '' },
            React.createElement(Input, { onChange: this.onChange, placeholder: "Enter a name to check availability", value: this.props.value || '' })));
    }
}
//# sourceMappingURL=index.js.map